/**********************************************************************
* generateTile.js - Shopify Collection List / Grid-Item / Tile Generator
* By: Tyler Heshka < tyler.h@floralacres.ca >
* 
* Version: 1.0
* Release Date: 2022-10-15
* License: Commercial. Licensed to Central Botanical Growers Ltd. o/a 
* Floral Acres Greenhouses & Garden Centre - https://floralacres.ca/
*
* This generareTile function will take parameters passed through the config array 
* and output a product card on the Shopify Debut Theme grid. Clicks are tracked
* using Google Analytics. All calls to the generateTile function must be wrapped
* in a DOMContentLoaded event listener/function, however, multiple calls to the
* function can all be within one event listener. 
*
* Usage: generateTile(config [array], debug [boolean]);

// Tile Generator 
document.addEventListener("DOMContentLoaded", function() {  
  generateTile({
    enabled: true, // true or false
    startDate: '1970-01-01', // start showing tile on this date, format yyyy-mm-dd
    endDate: '2970-12-31',  // stop showing tile on this date, format yyyy-mm-dd
    collection: 'all', // 'collection-handle' or 'all', comma-seperated for multiple
    exceptions: 'index', // 'collection-handle' to not show tiles on, comma-seperated for multiple
    position: '0', // 'first', 'last', 'random' or numeric tile position on grid -1
    container: 'AjaxinateContainer', // grid-items container ID
    productCardTitleText: 'Lorem Ipsum Dolor Amet', // title displayed on tile
    anchorURL: 'https://floralacres.ca/', // url when tile is clicked
    imageURL: 'http://via.placeholder.com/640' // image displayed on tile 
  }, false);
});

************************************************************************/

function generateTile(config, debug = true) {

  // debut theme classnames
  const gridClass = 'grid__item grid__item--collection-template small--one-half medium-up--one-quarter'; // the grid-item classname 
  const productCard = 'grid-view-item product-card'; // the product card classname
  const productCardTitle = 'h4 grid-view-item__title product-card__title'; // the product card title classname
  const anchorClass = 'grid-view-item__link grid-view-item__image-container'; // the anchor classname
  const imageWrapperClass = 'product-card__image-with-placeholder-wrapper'; // the image wrapper classname
  const imageClass = 'grid-view-item__image'; // the image classname
  
  // set default settings
  const defaultSettings = {
    enabled: true, // true or false
    startDate: '1970-01-01', // start showing tile on this date, format yyyy-mm-dd
    endDate: '2970-12-31',  // stop showing tile on this date, format yyyy-mm-dd
    collection: '', // 'collection-handle' or 'all', comma-seperated for multiple
    exceptions: '', // 'collection-handle' to not show tiles on, comma-seperated for multiple
    position: '0', // 'first', 'last', 'random' or numeric tile position on grid -1
    container: 'AjaxinateContainer', // grid-items container ID
    productCardTitleText: 'Lorem Ipsum Dolor Amet', // title displayed on tile
    anchorURL: 'https://floralacres.ca/', // url when tile is clicked
    imageURL: 'http://via.placeholder.com/640' // image displayed on tile 
  };

  // function to check if date is within range
  function checkDateRange(startDate, endDate) {
    // get current date 
    let dateObject = new Date();
    // convert string dates to date objects
    let startDateObject = new Date(startDate);
    let endDateObject = new Date(endDate);
    // check if the date is greater than the start date and less than the end date
    if (dateObject > startDateObject && dateObject < endDateObject) {
      // date is within range
      return true;
    } else {
      // date is not within range
      return false;
    }
  }
  
  // function to check if script is currently on colletion page
  function onCollectionPage(collectionList, exceptionList) {
    // get window path 
    let path = window.location.pathname;
    // get the potential handle (last place in url)
    let potentialHandle = path.substring(path.lastIndexOf("/") + 1);
    // handle multiple specified collections by splitting collectionList string into an array
    let collectionArray = collectionList.replace(/\s+/g, '').split(',');
    // handle multiple specified exceptions by splitting collectionList string into an array
    let exceptionArray = exceptionList.replace(/\s+/g, '').split(',');
    // check if potential handle exists in collection array
    if (!collectionList) {
      // invalid collection name throw error
      if (debug){console.warn('TILE: No collection(s) specified on tile: ' + settings.productCardTitleText);}
    } else if (collectionArray.includes(potentialHandle) || collectionArray.includes('all')) {
      //check for any exceptions 
      if (exceptionArray.includes(potentialHandle)) {
        // exception found
        if (debug){console.log('TILE: Collection(s) exception found on tile: ' + settings.productCardTitleText);}
        return false;
      } else {
        // valid collection name found
        return true;
      }
    } else {
      // not on collection
      return false;
    }
  }
  
  // function to create page elements
  function createElementItem(element, classname, inner) {
    // create element
    let e = document.createElement(element);
    // assign class
    e.className = classname;
    // assign text content
    e.textContent = inner;
    // return element
    return e;
  }
  
  // function to create image elements
  function createImgItem(classname, src, alt) {
    // create element
    let e = document.createElement('img');
    // assign class
    e.className = classname;
    // assign src
    e.src = src;
    // assign alt 
    e.alt = alt;
    // return element
    return e;
  }
  
  // function to create anchor elements
  function createAnchorItem(classname, href, target) {
    // create element
    let e = document.createElement('a');
    // assign class
    e.className = classname;
    // assign href
    e.href = href;
    // assign target
    e.target = target;
    // assign onCLick handler
    e.onclick = function () {
      // send GA event
      ga('send', {
        hitType: 'event',
        eventCategory: 'th_tiles',
        eventAction: 'click',
        eventLabel: settings.productCardTitleText
      });
    };
    // return element
    return e;
  }

  // get user config
  let settings = config || {};

  // merge user and default configs
  settings = Object.assign(defaultSettings, settings);
  
  // check if tile is enabled
  if (!settings.enabled) { 
    if(debug){console.log('TILE: "' + settings.productCardTitleText + '" is disabled!');}
    return false; 
  }

  // check if tile is within date range 
  if (!checkDateRange(settings.startDate, settings.endDate)) {
    if(debug){console.log('TILE: "' + settings.productCardTitleText + '" is not within date range!');}
    return false; 
  }

  // check if script is outputting to this collection page
  if (!onCollectionPage(settings.collection, settings.exceptions)) {
    if(debug){console.log('TILE: "' + settings.productCardTitleText + '" does not match this collection page.');}
    return false; 
  }

  // prepare to output elements
  if (!document.getElementById(settings.container)) {
    if(debug){console.log('TILE: No container element found to output tile "' + settings.productCardTitleText + '"');}
    return false; 
  } 

  // container element exists, get child nodes
  let doc = document.getElementById(settings.container).children;
  
  // Prepare to output elements 
  e1 = createElementItem('li', gridClass);
  e2 = createElementItem('div', productCard);
  e3 = createElementItem('div', imageWrapperClass);
  e4 = createImgItem(imageClass, settings.imageURL, settings.productCardTitleText);
  
  // Check if anchorURL is provided
  if (settings.anchorURL) {
      e5 = createAnchorItem(anchorClass, settings.anchorURL, '_SELF');
      e5.appendChild(e4); // add the image to the anchor
      e3.appendChild(e5); // add anchor to the image wrapper
  } else {
      e3.appendChild(e4); // No anchor, just append the image directly
  }
  
  // Create the title element (always add the title)
  e6 = createElementItem('p', productCardTitle, settings.productCardTitleText);
  e1.appendChild(e2); // Append the product card to the list item
  e2.appendChild(e3); // Append the image wrapper to the product card
  e2.appendChild(e6); // Append the title directly to the product card
  
  // If there's an anchorURL, wrap the title in an anchor
  if (settings.anchorURL) {
      e7 = createAnchorItem(anchorClass, settings.anchorURL, '_SELF');
      e7.appendChild(e6); // title wrapped in anchor
      e2.appendChild(e7); // append the anchor with title to the product card
  } else {
      e2.appendChild(e6); // append the title directly to the product card
  }

  // determine position in grid and output tile
  switch(settings.position) {
    case 'first':
      // get first position within range
      let nFirst = 0;
      // append elements to container
      doc.item(nFirst).before(e1);
      // alert user
      if(debug){console.log('TILE: "' + settings.productCardTitleText + '" was inserted at first postion: ' + nFirst);}
      break;

    case 'last':
      // get last position within range
      let nLast = doc.length;
      // append elements to container
      doc.item(nLast - 1).after(e1);
      // alert user
      if(debug){console.log('TILE: "' + settings.productCardTitleText + '" was inserted at last postion: ' + nLast);}
      break;

    case 'random':
      // get random position within range
      let nRandom = Math.floor(Math.random() * doc.length);
      // append elements to container
      doc.item(nRandom).before(e1);
      // alert user
      if(debug){console.log('TILE: "' + settings.productCardTitleText + '" was inserted at random postion: ' + nRandom);}
      break;

    default:
      if (settings.position > doc.length || settings.position == 0) {
        // warn user
        if(debug){console.warn('TILE: Invalid position ' + settings.position + ' specified on tile "' + settings.productCardTitleText + '"');}
        // invalid user position use default for output
        doc.item(defaultSettings.position.value).before(e1);
        // alert user
        if(debug){console.warn('TILE: "' + settings.productCardTitleText + '" was inserted at default postion: first');}
      } else {
        // valid position using user value for output
        doc.item(settings.position).before(e1);
        // alert user
        if(debug){console.log('TILE: "' + settings.productCardTitleText + '" was inserted at specified postion: ' + settings.position);}
      }
      break
  }
}